import React, { useEffect, useRef, useState } from 'react';
import { gsap } from 'gsap';
import { useGSAP } from '@gsap/react';

export default function ArrowBis({
    animated = true
}) {
    // Create a ref for the path element
    const pathRef = useRef(null);

    const [currentAnimated, setCurrentAnimated] = useState(animated);

    /*
    useGSAP(() => {
        const path = pathRef.current;

        // Get the length of the path
        const pathLength = path.getTotalLength();

        // Set initial strokeDasharray and strokeDashoffset to hide the path
        gsap.set(path, {
            strokeDasharray: pathLength,
            strokeDashoffset: pathLength,
            fillOpacity: 0, // Initially make the fill invisible
        });

        if (animated) {
            // Animate the strokeDashoffset to 0 to "draw" the path
            gsap.to(path, {
                strokeDashoffset: 0,
                duration: 1, // Duration of the animation in seconds
                ease: "power1.inOut",
                onComplete: () => {
                    // Smoother fill-opacity transition to gradually show the fill
                    gsap.to(path, {
                        fillOpacity: 1, // Animate to full fill opacity
                        duration: 0.5, // Control the fill-opacity duration
                        ease: "power2.out", // Smoother easing function
                    });
                },
            });
        }
    }, [currentAnimated]);
    */

    useEffect(() => {
        setCurrentAnimated(animated);
    }, [animated])

    return (
        <svg width="100%" height="100%" viewBox="0 0 125 78" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path ref={pathRef}
                fill="currentColor" // Set fill color to the current text color
                stroke="currentColor" // Add stroke color
                strokeWidth="0.25"
                fillOpacity="100" // Initially invisible fill
                d="M2.11066 4.47594C1.00779 4.53706 0.0641824 3.69255 0.00306402 2.58967C-0.0580543 1.48679 0.786458 0.543186 1.88934 0.482068L2.11066 4.47594ZM118.061 76.3794C117.699 77.4228 116.559 77.9749 115.516 77.6124L98.512 71.7065C97.4686 71.3441 96.9165 70.2044 97.279 69.161C97.6414 68.1176 98.781 67.5655 99.8245 67.9279L114.939 73.1777L120.188 58.0634C120.551 57.02 121.691 56.4679 122.734 56.8304C123.777 57.1928 124.329 58.3324 123.967 59.3759L118.061 76.3794ZM1.88934 0.482068C31.4351 -1.15528 53.0387 1.77187 71.0346 13.1374C88.9925 24.4789 103.04 44.0258 117.972 74.8513L114.372 76.5951C99.5277 45.9514 85.8847 27.2471 68.8986 16.5194C51.9505 5.81557 31.3564 2.85522 2.11066 4.47594L1.88934 0.482068Z" fill="black" />
        </svg>
    )
}